import { createRouter, createWebHistory } from "vue-router";


import MapEditor from "@/views/MapEditor.vue";
import MapViewer from "@/views/MapViewer.vue";
import MapHome from "@/views/MapHome.vue";

import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";

import MapList from "@/components/content/MapList.vue";

import TeamPanel from "@/components/content/TeamPanel.vue";

import TeamSetting from "@/components/content/TeamSetting.vue";

import MapSetting from "@/components/content/MapSetting.vue";

import LayerManager from "@/components/content/LayerManager.vue";

import CooperationManager from "@/components/content/CooperationManager.vue";

import ReplyManager from "@/components/content/ReplyManager.vue";

import FendanManager from "@/components/content/FendanManager.vue";

import LogManager from "@/components/content/LogManager.vue";

import ShareManager from "@/components/content/ShareManager.vue";

import UserList from "@/components/content/UserList.vue";


import MapContent from "@/components/content/MapContent.vue";

// 路由规则
const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/",
    name: "home",
    redirect: "/map/home",
  },
  {
    path: "/map/home",
    name: "mapHome",
    component: MapHome,
    children: [
      {
        path: "/map/list",
        name: "list",
        component: MapList
      },
      {
        path:"/map/content",
        name: "content",
        component: MapContent
      },
      {
        path: "/map/mapsetting",
        name: "mapsetting",
        component: MapSetting
      },
      {
        path: "/map/teampanel",
        name: "teampanel",
        component: TeamPanel
      },
      {
        path: "/map/teamsetting",
        name: "teamsetting",
        component: TeamSetting
      },
      {
        path: "/map/userlist",
        name: "userlist",
        component: UserList
      }
    ]
  },
  {
    path: "/map/editor",
    name: "mapEditor",
    component: MapEditor,
    children: [
      {
        path: "/map/layer",
        name: "layer",
        component: LayerManager
      },
      {
        path: "/map/cooperation",
        name: "cooperation",
        component: CooperationManager
      },
      {
        path: "/map/reply",
        name: "reply",
        component: ReplyManager
      },
      {
        path: "/map/fendan",
        name: "fendan",
        component: FendanManager
      },
      {
        path: "/map/log",
        name: "log",
        component: LogManager
      },
      {
        path: "/map/share",
        name: "share",
        component: ShareManager
      },
    ]
  },
  {
    path: "/map/viewer",
    name: "mapViewer",
    component: MapViewer,
  }

];
//根据路由规则创建路由
const router = createRouter({
  history: createWebHistory(""),
  routes,
});
export default router;